import LessonRemovedContainer from './container';

export default LessonRemovedContainer;
